import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  props: {},
})

export default class BetterCorpCoZaHome extends Vue {
  public readonly PartneredCompanies = [
    {
      imageUrl: '/img/svgs/FNB-Logo-Light.svg',
      alt: 'FNB'
    },
    {
      imageUrl: '/img/svgs/Mikrotik-Dark.svg',
      alt: 'MIKROTIK'
    },
    {
      imageUrl: '/img/svgs/Google-Dark.svg',
      alt: 'GOOGLE'
    },
    {
      imageUrl: '/img/svgs/Microsoft-Dark.svg',
      alt: 'MICROSOFT'
    },
    {
      imageUrl: '/img/svgs/PayFast-Dark.svg',
      alt: 'PAYFAST'
    },
    {
      imageUrl: '/img/svgs/Ubiquiti-Dark.svg',
      alt: 'UBIQUITI'
    },
    {
      imageUrl: '/img/GhostFibre-Dark.png',
      width: '320px',
      height: '80px',
      alt: 'GHOSTFIBRE'
    }
  ];
  public readonly ParallaxLogos = [
    // 'BETTERCORP',
    'FIBRE',
    'BRANDING',
    'NETWORKS',
    'TECH',
    'BNB',
  ];
}
